import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import './Tooltip.css';

interface TooltipProps {
  text: string;
}

const Tooltip: React.FC<TooltipProps> = ({ text }) => (
  <span className="tooltip-wrapper">
    <FaQuestionCircle className="tooltip-icon" />
    <span className="tooltip-text">{text}</span>
  </span>
);

export default Tooltip;
